import React from 'react';
import { Row, Col, Tabs } from 'antd';
import { Users, UserCheck } from 'lucide-react';
import VisitorListFunctional from './visitor-list-functional';
import { useI18n } from 'hooks/useI18n';

const VisitorsTab = () => {
	const { t } = useI18n();

	const tabItems = [
		{
			key: 'All',
			label: (
				<span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
					<Users size={16} />
					{t('visitors.tabs.all')}
				</span>
			),
			children: <VisitorListFunctional />,
		},
		{
			key: 'Converted',
			label: (
				<span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
					<UserCheck size={16} />
					{t('visitors.tabs.converted')}
				</span>
			),
			children: <VisitorListFunctional converted />,
		},
	];

	return (
		<Row className="visitors-tab-container" style={{ height: '80%' }}>
			<Col xl={24} className="container">
				<Tabs defaultActiveKey="All" destroyInactiveTabPane items={tabItems} />
			</Col>
		</Row>
	);
};

export default VisitorsTab;
